import { Box, Typography } from "@mui/material";
import React from "react";

const DataOpsPage: React.FC = () => {
  document.title = "Data Operations";

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        textAlign: "center",
      }}
    >
      <Typography
        variant="h4"
        sx={{
          px: 2,
          maxWidth: "100%",
          "@media (min-width: 1024px)": {
            maxWidth: "40%",
          },
        }}
        gutterBottom
      >
        “I must create a system, or be enslaved by another man's. I will not
        reason and compare: my business is to create.” 🐁
        <br />— William Blake
      </Typography>
    </Box>
  );
};

export default DataOpsPage;
